export default __webpack_public_path__ + "static/media/Image.fcaa2971.png";